import { Link } from 'react-router-dom';
import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavMenuContent({
  setOpen
}: {
  setOpen?: (open: boolean) => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="animate-pulse h-6 w-48 bg-gray-200 rounded"></div>;
  }
  return <>
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} onClick={() => setOpen?.(false)} className="transition-colors duration-150 hover:text-blue-600" style={{
      fontSize: "16px",
      fontWeight: 500,
      color: "#1E293B",
      textDecoration: "none",
      fontFamily: '"DM Sans", sans-serif',
      textTransform: "uppercase",
      letterSpacing: "0.05em"
    }}>
          {item.label}
        </Link>)}
    </>;
}
export default function Header() {
  const [open, setOpen] = useState(false);
  return <header id="header" className="sticky top-0 z-50 w-full bg-white" style={{
    borderBottom: "2px solid #020618",
    fontFamily: '"DM Sans", sans-serif'
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Outfit:wght@700&display=swap');`}</style>
      <div className="page-container">
        <div className="flex items-center justify-between" style={{
        height: "72px"
      }}>
          <Link to="/" className="flex-shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1710017/img/6033f720-fa09-40cb-b4b8-5719b3bb6019_d04c9f008d.jpg" alt="CSN Digital" className="h-auto" style={{
            width: "151px",
            maxHeight: "40px",
            objectFit: "contain"
          }} src="https://hardy-tortoise-1.10web.cloud/wp-content/uploads/2026/06/CSN_Logo_2026.png" />
          </Link>

          <nav className="hidden md:flex items-center" style={{
          backgroundPosition: "0% 0%",
          backgroundRepeat: "repeat",
          color: "rgb(2, 8, 23)",
          fontFamily: '"DM Sans", sans-serif',
          alignItems: "center",
          animation: "none 0s ease 0s 1 normal none running",
          gap: "48px",
          columnGap: "48px",
          rowGap: "48px"
        }}>
            <MenuProvider menu_id="16">
              <NavMenuContent />
            </MenuProvider>
          </nav>

          <div className="hidden md:flex items-center">
            <Link to="#consultation">
              <button className="hover:scale-105 transition-all duration-200 cursor-pointer" style={{
              backgroundColor: "#2563EB",
              color: "#FFFFFF",
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "15px",
              fontWeight: 600,
              borderRadius: "9999px",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
              border: "none",
              boxShadow: "0px 10px 15px -3px rgba(37, 99, 235, 0.25), 0px 4px 6px -4px rgba(37, 99, 235, 0.25)",
              cursor: "pointer",
              whiteSpace: "nowrap"
            }}>
                Get My Free Consultation &rarr;
              </button>
            </Link>
          </div>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="md:hidden flex flex-col justify-center items-center gap-1.5 p-2 cursor-pointer" style={{
              background: "none",
              border: "none"
            }} aria-label="Open menu">
                <span className="block w-6 h-0.5 bg-gray-800"></span>
                <span className="block w-6 h-0.5 bg-gray-800"></span>
                <span className="block w-6 h-0.5 bg-gray-800"></span>
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <SheetHeader>
                <SheetTitle>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1710017/img/6033f720-fa09-40cb-b4b8-5719b3bb6019_d04c9f008d.jpg" alt="CSN Digital" className="h-auto" style={{
                  width: "120px",
                  objectFit: "contain"
                }} />
                </SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-8 mt-8 px-2">
                <MenuProvider menu_id="16">
                  <NavMenuContent setOpen={setOpen} />
                </MenuProvider>
                <Link to="#consultation" onClick={() => setOpen(false)}>
                  <button className="w-full hover:scale-105 transition-all duration-200 cursor-pointer mt-4" style={{
                  backgroundColor: "#2563EB",
                  color: "#FFFFFF",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "15px",
                  fontWeight: 600,
                  borderRadius: "9999px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  border: "none",
                  boxShadow: "0px 10px 15px -3px rgba(37, 99, 235, 0.25), 0px 4px 6px -4px rgba(37, 99, 235, 0.25)",
                  cursor: "pointer"
                }}>
                    Get My Free Consultation &rarr;
                  </button>
                </Link>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}